/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Col } from 'reactstrap';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, ComposedChart, Line
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../../utils/helpers';

const AdvBudgetChart = ({
  dir, campaign, showTitle,
  height,
  index
}) => {

  const [color1] = colorsCombination[(index) % 10];


  const dataToShow = [];

  campaign?.campaignNameWise?.forEach((item) => {
    dataToShow.push({
      title: campaign.title,
      day: moment(item.reportDate).format('MM-DD-YYYY'),
      "Daily Budget Amount": Number(item.dailyBudget),
      "Sales": Number(item.sales),
      "Cost": Number(item.cost)
    })
  })

  return (
    <Col xs={12}>

      {showTitle ? <div className="card__title">
        <h5 className="bold-text">Adv Budget Performance By Campaign</h5>
      </div> : null}
      <div dir="ltr">
        <ResponsiveContainer height={height}>
          <ComposedChart
            data={dataToShow}
            margin={{
              top: 0, right: 0, left: 25, bottom: 0,
            }}
          >
            <XAxis dataKey="day" reversed={dir === 'rtl'} />
            <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
              tickFormatter={item => setCurrencyFormat(item, true)}
              width={90}
              allowDataOverflow
            />
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <Tooltip formatter={value => setCurrencyFormat(value, true)} />
            <Legend />
            <Bar type="monotone" dataKey={"Daily Budget Amount".toString()} fill={color1} />
            <Line strokeWidth={2} dot={false} dataKey={"Cost".toString()} stroke="#8B0000		" />
            <Line dot={false} dataKey={"Sales".toString()} stroke="#000000" />

          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Col>
  );
};

AdvBudgetChart.propTypes = {
  dir: PropTypes.string.isRequired,
  campaign: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  showTitle: PropTypes.bool,
  index: PropTypes.number,
};

AdvBudgetChart.defaultProps = {
  showTitle: true,
  index: 0
}

export default AdvBudgetChart;
